import { api } from "boot/axios";

export const updateIndex = async () => {
  try {
    const resp = await api.get("/utils/update_els/");
    return Promise.resolve(resp);
  } catch (error) {
    console.log(error);
    return Promise.reject("");
  }
};


export const updateIndexUsers = async () => {
  try {
    const resp = await api.get("/social/user/search/update/");
    return Promise.resolve(resp);
  } catch (error) {
    console.log(error);
    return Promise.reject("");
  }
};


export const updateIndexVideos = async () => {
  try {
    const resp = await api.get("/social/video/search/update/");
    return Promise.resolve(resp);
  } catch (error) {
    console.log(error);
    return Promise.reject("");
  }
};

export const updateIndexB2BCourses = async () => {
  try {
    const resp = await api.get("/company/search/update/");
    return Promise.resolve(resp);
  } catch (error) {
    console.log(error);
    return Promise.reject("");
  }
};
